import React from 'react';

import { range } from 'lodash';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

/** Placeholder rows with a status line naming what is loading. */
export default function TableSkeleton({ status, columns = 4, rows = 9 }) {
    return (
        <div className="tw-px-5 tw-pb-5 tw-pt-4" aria-busy="true">
            <div className="tw-mb-4 tw-flex tw-items-center tw-gap-x-2.5 tw-text-sm tw-text-charcoal-50" role="status">
                <LoadingSpinner size="xs" ySpacing={false} />
                <span>{status}</span>
            </div>
            {range(rows).map((row) => (
                <div key={row} className="tw-mb-3 tw-flex tw-items-center tw-gap-x-3">
                    <div className={row % 3 ? 'tw-ps-6' : ''} style={{ width: row % 3 ? 236 : 170 }}>
                        <Skeleton height={14} />
                    </div>
                    {range(columns).map((column) => (
                        <div key={column} className="tw-ms-auto" style={{ width: 90 + ((row + column) % 3) * 14 }}>
                            <Skeleton height={14} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
